// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.core-people-page {
    background: #ffffff;
}

.core-people-section {
    padding-top: 48px;
    padding-bottom: 8px;
}

.core-people-page .core-people-section:last-of-type {
    padding-bottom: 48px;
}

.core-people-hero {
    position: relative;
    overflow: hidden;
    min-height: 56vh;
    display: flex;
    align-items: center;
    background:
        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),
        #0d0d10;
    color: #ffffff;
}

.core-people-hero-bg {
    position: absolute;
    inset: 0;
}

.core-people-grid {
    position: absolute;
    inset: -24%;
    background-image:
        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);
    background-size: 44px 44px;
    transform: perspective(720px) rotateX(64deg);
    animation: corePeopleGridMove 24s linear infinite;
}

.core-people-glow {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),
        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);
}

.core-people-hero-content {
    position: relative;
    z-index: 1;
    padding-top: 132px;
    padding-bottom: 72px;
}

.core-people-kicker {
    display: inline-flex;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.core-people-hero-title {
    margin: 18px 0 14px;
    font-size: clamp(2.5rem, 5vw, 4.5rem);
    line-height: 1.04;
}

.core-people-hero-description {
    max-width: 720px;
    color: rgba(255, 255, 255, 0.82);
    font-size: 1.04rem;
    line-height: 1.82;
}

.core-people-featured-grid {
    display: grid;
    grid-template-columns: 1.15fr 1fr 1fr;
    gap: 18px;
}

.core-people-grid-layout {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;
}

.core-people-grid-layout-two {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.core-people-group-stack {
    display: grid;
    gap: 18px;
}

.core-people-group-panel,
.core-people-member-card {
    border-radius: 24px;
    border: 1px solid rgba(217, 0, 27, 0.08);
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 14px 32px rgba(22, 22, 26, 0.05);
}

.core-people-group-panel {
    padding: 22px;
}

.core-people-group-head {
    margin-bottom: 16px;
}

.core-people-group-head h3 {
    font-size: 1.4rem;
    line-height: 1.2;
}

.core-people-member-card {
    height: 100%;
    display: grid;
    grid-template-columns: 112px 1fr;
    gap: 18px;
    padding: 18px;
}

.core-people-member-card.is-hero-card {
    grid-template-columns: 180px 1fr;
    padding: 22px;
}

.core-people-member-card.is-featured-card {
    grid-template-columns: 140px 1fr;
    padding: 20px;
}

.core-people-member-visual {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 20px;
    background: #f1f1f1;
    overflow: hidden;
    display: grid;
    place-items: center;
    color: #8a8a8a;
    font-size: 2rem;
    font-weight: 700;
}

.core-people-member-visual.has-image {
    background: #f5f5f5;
}

.core-people-member-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
}

.core-people-member-copy {
    min-width: 0;
}

.core-people-member-copy h3 {
    margin-bottom: 4px;
    font-size: 1.22rem;
    line-height: 1.35;
    color: var(--text-main);
}

.core-people-member-card.is-hero-card .core-people-member-copy h3 {
    font-size: 1.5rem;
}

.core-people-member-title {
    margin-bottom: 10px;
    color: var(--accent-red);
    font-weight: 700;
    line-height: 1.6;
}

.core-people-member-lines {
    display: grid;
    gap: 4px;
}

.core-people-member-lines p {
    color: var(--text-light);
    line-height: 1.78;
}

@keyframes corePeopleGridMove {
    from {
        transform: perspective(720px) rotateX(64deg) translateY(0);
    }

    to {
        transform: perspective(720px) rotateX(64deg) translateY(44px);
    }
}

@media (max-width: 1100px) {
    .core-people-featured-grid,
    .core-people-grid-layout,
    .core-people-grid-layout-two {
        grid-template-columns: 1fr 1fr;
    }

    .core-people-featured-grid > :first-child {
        grid-column: 1 / -1;
    }
}

@media (max-width: 768px) {
    .core-people-section {
        padding-top: 40px;
    }

    .core-people-hero-content {
        padding-top: 118px;
        padding-bottom: 60px;
    }

    .core-people-featured-grid,
    .core-people-grid-layout,
    .core-people-grid-layout-two {
        grid-template-columns: 1fr;
    }

    .core-people-group-panel {
        padding: 18px;
        border-radius: 20px;
    }

    .core-people-member-card,
    .core-people-member-card.is-hero-card,
    .core-people-member-card.is-featured-card {
        grid-template-columns: 88px 1fr;
        gap: 14px;
        padding: 16px;
        border-radius: 18px;
    }

    .core-people-member-copy h3,
    .core-people-member-card.is-hero-card .core-people-member-copy h3 {
        font-size: 1.12rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/core-people.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB;;eAEW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;;+EAE2E;IAC3E,0BAA0B;IAC1B,4CAA4C;IAC5C,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;;sFAEkF;AACtF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,mBAAmB;IACnB,wCAAwC;IACxC,qCAAqC;IACrC,8CAA8C;AAClD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI;QACI,0DAA0D;IAC9D;;IAEA;QACI,6DAA6D;IACjE;AACJ;;AAEA;IACI;;;QAGI,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;;QAGI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;;;QAGI,+BAA+B;QAC/B,SAAS;QACT,aAAa;QACb,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;IACtB;AACJ","sourcesContent":[".core-people-page {\r\n    background: #ffffff;\r\n}\r\n\r\n.core-people-section {\r\n    padding-top: 48px;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.core-people-page .core-people-section:last-of-type {\r\n    padding-bottom: 48px;\r\n}\r\n\r\n.core-people-hero {\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-height: 56vh;\r\n    display: flex;\r\n    align-items: center;\r\n    background:\r\n        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),\r\n        #0d0d10;\r\n    color: #ffffff;\r\n}\r\n\r\n.core-people-hero-bg {\r\n    position: absolute;\r\n    inset: 0;\r\n}\r\n\r\n.core-people-grid {\r\n    position: absolute;\r\n    inset: -24%;\r\n    background-image:\r\n        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),\r\n        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);\r\n    background-size: 44px 44px;\r\n    transform: perspective(720px) rotateX(64deg);\r\n    animation: corePeopleGridMove 24s linear infinite;\r\n}\r\n\r\n.core-people-glow {\r\n    position: absolute;\r\n    inset: 0;\r\n    background:\r\n        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),\r\n        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);\r\n}\r\n\r\n.core-people-hero-content {\r\n    position: relative;\r\n    z-index: 1;\r\n    padding-top: 132px;\r\n    padding-bottom: 72px;\r\n}\r\n\r\n.core-people-kicker {\r\n    display: inline-flex;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.core-people-hero-title {\r\n    margin: 18px 0 14px;\r\n    font-size: clamp(2.5rem, 5vw, 4.5rem);\r\n    line-height: 1.04;\r\n}\r\n\r\n.core-people-hero-description {\r\n    max-width: 720px;\r\n    color: rgba(255, 255, 255, 0.82);\r\n    font-size: 1.04rem;\r\n    line-height: 1.82;\r\n}\r\n\r\n.core-people-featured-grid {\r\n    display: grid;\r\n    grid-template-columns: 1.15fr 1fr 1fr;\r\n    gap: 18px;\r\n}\r\n\r\n.core-people-grid-layout {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, minmax(0, 1fr));\r\n    gap: 18px;\r\n}\r\n\r\n.core-people-grid-layout-two {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n}\r\n\r\n.core-people-group-stack {\r\n    display: grid;\r\n    gap: 18px;\r\n}\r\n\r\n.core-people-group-panel,\r\n.core-people-member-card {\r\n    border-radius: 24px;\r\n    border: 1px solid rgba(217, 0, 27, 0.08);\r\n    background: rgba(255, 255, 255, 0.98);\r\n    box-shadow: 0 14px 32px rgba(22, 22, 26, 0.05);\r\n}\r\n\r\n.core-people-group-panel {\r\n    padding: 22px;\r\n}\r\n\r\n.core-people-group-head {\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.core-people-group-head h3 {\r\n    font-size: 1.4rem;\r\n    line-height: 1.2;\r\n}\r\n\r\n.core-people-member-card {\r\n    height: 100%;\r\n    display: grid;\r\n    grid-template-columns: 112px 1fr;\r\n    gap: 18px;\r\n    padding: 18px;\r\n}\r\n\r\n.core-people-member-card.is-hero-card {\r\n    grid-template-columns: 180px 1fr;\r\n    padding: 22px;\r\n}\r\n\r\n.core-people-member-card.is-featured-card {\r\n    grid-template-columns: 140px 1fr;\r\n    padding: 20px;\r\n}\r\n\r\n.core-people-member-visual {\r\n    width: 100%;\r\n    aspect-ratio: 1 / 1;\r\n    border-radius: 20px;\r\n    background: #f1f1f1;\r\n    overflow: hidden;\r\n    display: grid;\r\n    place-items: center;\r\n    color: #8a8a8a;\r\n    font-size: 2rem;\r\n    font-weight: 700;\r\n}\r\n\r\n.core-people-member-visual.has-image {\r\n    background: #f5f5f5;\r\n}\r\n\r\n.core-people-member-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    object-fit: cover;\r\n    object-position: center;\r\n}\r\n\r\n.core-people-member-copy {\r\n    min-width: 0;\r\n}\r\n\r\n.core-people-member-copy h3 {\r\n    margin-bottom: 4px;\r\n    font-size: 1.22rem;\r\n    line-height: 1.35;\r\n    color: var(--text-main);\r\n}\r\n\r\n.core-people-member-card.is-hero-card .core-people-member-copy h3 {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.core-people-member-title {\r\n    margin-bottom: 10px;\r\n    color: var(--accent-red);\r\n    font-weight: 700;\r\n    line-height: 1.6;\r\n}\r\n\r\n.core-people-member-lines {\r\n    display: grid;\r\n    gap: 4px;\r\n}\r\n\r\n.core-people-member-lines p {\r\n    color: var(--text-light);\r\n    line-height: 1.78;\r\n}\r\n\r\n@keyframes corePeopleGridMove {\r\n    from {\r\n        transform: perspective(720px) rotateX(64deg) translateY(0);\r\n    }\r\n\r\n    to {\r\n        transform: perspective(720px) rotateX(64deg) translateY(44px);\r\n    }\r\n}\r\n\r\n@media (max-width: 1100px) {\r\n    .core-people-featured-grid,\r\n    .core-people-grid-layout,\r\n    .core-people-grid-layout-two {\r\n        grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    .core-people-featured-grid > :first-child {\r\n        grid-column: 1 / -1;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .core-people-section {\r\n        padding-top: 40px;\r\n    }\r\n\r\n    .core-people-hero-content {\r\n        padding-top: 118px;\r\n        padding-bottom: 60px;\r\n    }\r\n\r\n    .core-people-featured-grid,\r\n    .core-people-grid-layout,\r\n    .core-people-grid-layout-two {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .core-people-group-panel {\r\n        padding: 18px;\r\n        border-radius: 20px;\r\n    }\r\n\r\n    .core-people-member-card,\r\n    .core-people-member-card.is-hero-card,\r\n    .core-people-member-card.is-featured-card {\r\n        grid-template-columns: 88px 1fr;\r\n        gap: 14px;\r\n        padding: 16px;\r\n        border-radius: 18px;\r\n    }\r\n\r\n    .core-people-member-copy h3,\r\n    .core-people-member-card.is-hero-card .core-people-member-copy h3 {\r\n        font-size: 1.12rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
